import { Action } from '@ngrx/store';
import * as FixedTemplatesTypes from './fixed-templates.types'
import { FixedTemplate } from './fixed-templates.interface';

export class FetchFixedTemplatesRequest implements Action {
    readonly type = FixedTemplatesTypes.FETCH_FIXED_TEMPLATES_REQUEST;
    constructor(public payload: any = {}) { }
}


export class FetchFixedTemplatesSuccess implements Action {
    readonly type = FixedTemplatesTypes.FETCH_FIXED_TEMPLATES_SUCCESS;
    constructor(public payload: Array<FixedTemplate>) { }
}


export class FetchFixedTemplatesFailure implements Action {
    readonly type = FixedTemplatesTypes.FETCH_FIXED_TEMPLATES_FAILURE;
    constructor(public payload: any) { }
}

export class UpdateFixedTemplatesRequest implements Action {
    readonly type = FixedTemplatesTypes.UPDATE_FIXED_TEMPLATES_REQUEST;
    constructor(public id: number, public payload) { }
}

export class UpdateFixedTemplatesSuccess implements Action {
    readonly type = FixedTemplatesTypes.UPDATE_FIXED_TEMPLATES_SUCCESS;
    constructor() { }
}


export class UpdateFixedTemplatesFailure implements Action {
    readonly type = FixedTemplatesTypes.UPDATE_FIXED_TEMPLATES_FAILURE;
    constructor(public payload: any) { }
}

export class UpdateField implements Action {
    readonly type = FixedTemplatesTypes.UPDATE_FIELD;
    public constructor(public field: string, public value: any, public path: string) { }
}

export class SetDefaultData implements Action {
    readonly type = FixedTemplatesTypes.SET_DEFAULT_DATA;
    public constructor(public path: string) { }
}


export type Actions = UpdateFixedTemplatesRequest | UpdateFixedTemplatesSuccess | UpdateFixedTemplatesFailure |
    FetchFixedTemplatesSuccess | FetchFixedTemplatesFailure | FetchFixedTemplatesRequest |
    SetDefaultData | UpdateField;
